import { FirebaseDocRefType } from 'firebase/index'
import { Action, Dispatch } from 'redux'
import { State } from 'index'
import { SwitchingStoreRefType } from 'types/auth'
import { fetchSwitchingStoreRefsAction } from 'reducks/auth/actions'

const fetchAdminSwitchingStoreRefs = (storeRef: FirebaseDocRefType) => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    const switchingStoreRefs: SwitchingStoreRefType[] = []
    const manufacturerRef: FirebaseDocRefType = getState().auth.manufacturer_ref
    switchingStoreRefs.push({
      store_ref: storeRef,
      manufacturer_ref: manufacturerRef,
      is_event_staff: false,
    })
    dispatch(fetchSwitchingStoreRefsAction(switchingStoreRefs))
  }
}

export default fetchAdminSwitchingStoreRefs
